export enum CONTENT_ADMIN {
    /**
     * @value All content
     * @description Menu entrie for a page displaying all content
     */
    ALL_CONTENT = 'CONTENT.ALL_CONTENT',
    /**
     * @value All content selected (%NUMBER%)
     */
    ALL_CONTENT_SELECTED = 'CONTENT_ADMIN.ALL_CONTENT_SELECTED',
    /**
     * @value All content updated.
     * @description Description of the content bulk notification that notify that every content have been successfully updated
     */
    ALL_CONTENT_UPDATED = 'CONTENT_ADMIN.ALL_CONTENT_UPDATED',
    /**
     * @value Analyze content
     */
    ANALYZE_CONTENT = 'CONTENT_ADMIN.ANALYZE_CONTENT',
    /**
     * @value Analyze the quality of the selected content.
     */
    ANALYZE_CONTENT_INITIAL_MESSAGE = 'CONTENT_ADMIN.ANALYZE_CONTENT_INITIAL_MESSAGE',
    /**
     * @value A bulk action was launched by another administrator, and only one bulk action can work at a time.
     *
     * Try again in a few minutes.
     */
    ANOTHER_BULK_ACTION_IN_PROGRESS_DESCRIPTION = 'CONTENT_ADMIN.ANOTHER_BULK_ACTION_IN_PROGRESS_DESCRIPTION',
    /**
     * @value Another bulk action is in progress
     */
    ANOTHER_BULK_ACTION_IN_PROGRESS_TITLE = 'CONTENT_ADMIN.ANOTHER_BULK_ACTION_IN_PROGRESS_TITLE',
    /**
     * @value Only updates the content owner, not the displayed author (when published on behalf of someone else).
     */
    BULK_AUTHOR_EDITION_HELPER = 'CONTENT_ADMIN.BULK_AUTHOR_EDITION_HELPER',
    /**
     * @value Bulk action done
     */
    BULK_DONE = 'CONTENT_ADMIN.BULK_DONE',
    /**
     * @value Error in bulk action
     */
    BULK_ERROR = 'CONTENT_ADMIN.BULK_ERROR',
    /**
     * @value Bulk action in progress
     */
    BULK_IN_PROGRESS = 'CONTENT_ADMIN.BULK_IN_PROGRESS',
    /**
     * @value %NUMBER% content selected updated with the following:
     * @description Title used on a bulk operation details dialog, informing the user of the number of content he updated
     */
    BULK_OPERATION_DETAILS_TITLE = 'CONTENT_ADMIN.BULK_OPERATION_DETAILS_TITLE',
    /**
     * @value A bulk action was launched by another administrator, and only one bulk action can work at a time.
     */
    BULK_STARTED_BY_SOMEONE = 'CONTENT_ADMIN.BULK_STARTED_BY_SOMEONE',
    /**
     * @value Content updates completed
     * @description Title of the bulk notification that appear at the end of a successful bulk operation
     */
    BULK_UPDATE_COMPLETED = 'CONTENT_ADMIN.BULK_UPDATE_COMPLETED',
    /**
     * @value Content updates completed with errors
     * @description Title of the notification that is displayed when a bulk ends with errors for some content
     */
    BULK_UPDATE_COMPLETED_WITH_ERRORS = 'CONTENT_ADMIN.BULK_UPDATE_COMPLETED_WITH_ERRORS',
    /**
     * @value These changes may take a few minutes.
     */
    CHANGES_MAY_TAKE_A_FEW_MINUTES = 'CONTENT_ADMIN.CHANGES_MAY_TAKE_A_FEW_MINUTES',
    /**
     * @value {"one":"<strong>%CONTENT_COUNT% piece of content will be updated<\/strong> with the following:","other":"<strong>%CONTENT_COUNT% pieces of content will be updated<\/strong> with the following:"}
     */
    CHANGES_OVERVIEW = 'CONTENT_ADMIN.CHANGES_OVERVIEW',
    /**
     * @value Author: %AUTHOR%
     */
    CHANGES_OVERVIEW_AUTHOR = 'CONTENT_ADMIN.CHANGES_OVERVIEW_AUTHOR',
    /**
     * @value Expiration date: %DATE%
     */
    CHANGES_OVERVIEW_EXPIRATION_DATE = 'CONTENT_ADMIN.CHANGES_OVERVIEW_EXPIRATION_DATE',
    /**
     * @value Archive content?
     */
    CONFIRM_ARCHIVE = 'CONTENT_ADMIN.CONFIRM_ARCHIVE',
    /**
     * @value Archive %CONTENT_COUNT% content?
     */
    CONFIRM_ARCHIVE_MULTIPLE = 'CONTENT_ADMIN.CONFIRM_ARCHIVE_MULTIPLE',
    /**
     * @value Confirm changes?
     */
    CONFIRM_CHANGES = 'CONTENT_ADMIN.CONFIRM_CHANGES',
    /**
     * @value Delete content?
     * @description Confirmation to delete a content
     */
    CONFIRM_DELETE = 'CONTENT_ADMIN.CONFIRM_DELETE',
    /**
     * @value Delete %CONTENT_COUNT% content?
     * @description Confirmation to delete som pieces of content
     */
    CONFIRM_DELETE_MULTIPLE = 'CONTENT_ADMIN.CONFIRM_DELETE_MULTIPLE',
    /**
     * @value Publish content?
     */
    CONFIRM_PUBLISH = 'CONTENT_ADMIN.CONFIRM_PUBLISH',
    /**
     * @value Publish %CONTENT_COUNT% content?
     */
    CONFIRM_PUBLISH_MULTIPLE = 'CONTENT_ADMIN.CONFIRM_PUBLISH_MULTIPLE',
    /**
     * @value Unarchive content?
     */
    CONFIRM_UNARCHIVE = 'CONTENT_ADMIN.CONFIRM_UNARCHIVE',
    /**
     * @value Unarchive %CONTENT_COUNT% content?
     */
    CONFIRM_UNARCHIVE_MULTIPLE = 'CONTENT_ADMIN.CONFIRM_UNARCHIVE_MULTIPLE',
    /**
     * @value Unpublish content?
     */
    CONFIRM_UNPUBLISH = 'CONTENT_ADMIN.CONFIRM_UNPUBLISH',
    /**
     * @value Unpublish %CONTENT_COUNT% content?
     */
    CONFIRM_UNPUBLISH_MULTIPLE = 'CONTENT_ADMIN.CONFIRM_UNPUBLISH_MULTIPLE',
    /**
     * @value %CONTENT_COUNT% content not updated due to an error.
     * @description Description of the notification that appear when a bulk ends with some content in error
     */
    COUNT_CONTENT_NOT_UPDATED_DUE_TO_ERROR = 'CONTENT_ADMIN.COUNT_CONTENT_NOT_UPDATED_DUE_TO_ERROR',
    /**
     * @value Not available during multiselection
     * @description Tooltip text displayed on content management when selecting multiple items and hovering the "Edit actions" inline button
     */
    DISABLED_INLINE_ACTION_TOOLTIP = 'CONTENT_ADMIN.DISABLED_INLINE_ACTION_TOOLTIP',
    /**
     * @value Only one bulk action can work at a time. Wait for the current bulk action to be done.
     */
    DISABLED_WHILE_RUNNING_TOOLTIP = 'CONTENT_ADMIN.DISABLED_WHILE_RUNNING_TOOLTIP',
    /**
     * @value Schedule view
     * @description "Schedule view" is a display mode for a Calendar component that will show a Calendar with all events planned after a specified date
     */
    EDITORIAL_PLANNING = 'CALENDAR.SCHEDULE_VIEW',
    /**
     * @value Error in content updates
     * @description Title of the notification that shows up when there is an error on content bulk
     */
    ERROR_IN_CONTENT_UPDATE = 'CONTENT_ADMIN.ERROR_IN_CONTENT_UPDATE',
    /**
     * @value An error occurred while updating content. No content have been updated.
     * @description Description of the notification that shows up when there is an error on content bulk
     */
    ERROR_IN_CONTENT_UPDATE_DESCRIPTION = 'CONTENT_ADMIN.ERROR_IN_CONTENT_UPDATE_DESCRIPTION',
    /**
     * @value Error in editing options
     */
    ERROR_IN_EDITING_OPTIONS = 'CONTENT_ADMIN.ERROR_IN_EDITING_OPTIONS',
    /**
     * @value An error occurred while editing the options of the selected pieces of content.
     */
    ERROR_IN_EDITING_OPTIONS_DESCRIPTION = 'CONTENT_ADMIN.ERROR_IN_EDITING_OPTIONS_DESCRIPTION',
    /**
     * @value Is after
     * @description Used in a field attached to a Datepicker to inform the user how the selected Date will be used for filtering.
     */
    EXPIRATION_DATE_AFTER = 'CONTENT_ADMIN.EXPIRATION_DATE_AFTER',
    /**
     * @value Expiration date is after: %DATE%
     */
    EXPIRATION_DATE_AFTER_ACTIVE = 'CONTENT_ADMIN.EXPIRATION_DATE_AFTER_ACTIVE',
    /**
     * @value Is before
     * @description Used in a field attached to a Datepicker to inform the suer how the selected Date will be used for filtering.
     */
    EXPIRATION_DATE_BEFORE = 'CONTENT_ADMIN.EXPIRATION_DATE_BEFORE',
    /**
     * @value Expiration date is before: %DATE%
     * @description Used to display the formated selected date in the filter tooltip.
     */
    EXPIRATION_DATE_BEFORE_ACTIVE = 'CONTENT_ADMIN.EXPIRATION_DATE_BEFORE_ACTIVE',
    /**
     * @value Expiration date must only come after the current date and time
     */
    EXPIRATION_DATE_DATE_TOO_OLD_ERROR = 'CONTENT_ADMIN.EXPIRATION_DATE_DATE_TOO_OLD_ERROR',
    /**
     * @value Updating the expiration date can republish or unpublish content.
     */
    EXPIRATION_DATE_FIELD_HELPER = 'CONTENT_ADMIN.EXPIRATION_DATE_FIELD_HELPER',
    /**
     * @value Is on
     * @description Used in a field attached to a Datepicker to inform the user how the Date selected will be used for filtering.
     */
    EXPIRATION_DATE_ON = 'CONTENT_ADMIN.EXPIRATION_DATE_ON',
    /**
     * @value Expiration date is on: %DATE%
     */
    EXPIRATION_DATE_ON_ACTIVE = 'CONTENT_ADMIN.EXPIRATION_DATE_ON_ACTIVE',
    /**
     * @value Expiration time
     */
    EXPIRATION_TIME = 'CONTENT_ADMIN.EXPIRATION_TIME',
    /**
     * @value Expires in: %DATE%
     */
    EXPIRES_IN_DATE = 'CONTENT_ADMIN.EXPIRES_IN_DATE',
    /**
     * @value Expires on: %DATE%
     */
    EXPIRES_ON_DATE = 'CONTENT_ADMIN.EXPIRES_ON_DATE',
    /**
     * @value Archived pieces of content can be found under the “Archived” filter.
     */
    EXPLAIN_ARCHIVE = 'CONTENT_ADMIN.EXPLAIN_ARCHIVE',
    /**
     * @value You can unarchive these pieces of content at any time.
     */
    EXPLAIN_ARCHIVE_MULTIPLE = 'CONTENT_ADMIN.EXPLAIN_ARCHIVE_MULTIPLE',
    /**
     * @value You can unarchive the content <strong>%CONTENT_NAME%</strong> at any time.
     */
    EXPLAIN_ARCHIVE_ONE = 'CONTENT_ADMIN.EXPLAIN_ARCHIVE_ONE',
    /**
     * @value The archived content <strong>%CONTENT_NAME%</strong> can be found under the “Archived” filter.
     */
    EXPLAIN_ARCHIVE_WITH_CONTENT_NAME = 'CONTENT_ADMIN.EXPLAIN_ARCHIVE_WITH_CONTENT_NAME',
    /**
     * @value {"one":"Deleting a content is irreversible. You will delete its entire configuration.","other":"Deleting %CONTENT_COUNT% content is irreversible. You will delete their entire configuration."}
     */
    EXPLAIN_DELETE = 'CONTENT_ADMIN.EXPLAIN_DELETE',
    /**
     * @value These pieces of content will be visible based on their publication options.
     */
    EXPLAIN_PUBLISH_MULTIPLE = 'CONTENT_ADMIN.EXPLAIN_PUBLISH_MULTIPLE',
    /**
     * @value The content <strong>%CONTENT_NAME%</strong> will be visible based on its publication options.
     */
    EXPLAIN_PUBLISH_ONE = 'CONTENT_ADMIN.EXPLAIN_PUBLISH_ONE',
    /**
     * @value Unarchived pieces of content revert to the “Draft” status.
     */
    EXPLAIN_UNARCHIVE_MULTIPLE = 'CONTENT_ADMIN.EXPLAIN_UNARCHIVE_MULTIPLE',
    /**
     * @value The content <strong>%CONTENT_NAME%</strong> will go back to the "Draft" status.
     */
    EXPLAIN_UNARCHIVE_ONE = 'CONTENT_ADMIN.EXPLAIN_UNARCHIVE_ONE',
    /**
     * @value Unpublished pieces of content are no longer visible and go back to the “Draft” status.
     */
    EXPLAIN_UNPUBLISH_MULTIPLE = 'CONTENT_ADMIN.EXPLAIN_UNPUBLISH_MULTIPLE',
    /**
     * @value The content <strong>%CONTENT_NAME%</strong> will not be visible anymore and will go back to the “Draft” status.
     */
    EXPLAIN_UNPUBLISH_ONE = 'CONTENT_ADMIN.EXPLAIN_UNPUBLISH_ONE',
    /**
     * @value Filter by inactive content authors
     */
    FILTER_BY_INACTIVE_AUTHOR = 'CONTENT_ADMIN.FILTER_BY_INACTIVE_AUTHOR',
    /**
     * @value {"one":"Not available for this content","other":"Not available for these content"}
     */
    INCOMPATIBLE_ACTION = 'CONTENT_ADMIN.INCOMPATIBLE_ACTION',
    /**
     * @value %CONTENT_COUNT% content updated.
     */
    MULTIPLE_CONTENT_UPDATED = 'CONTENT_ADMIN.MULTIPLE_CONTENT_UPDATED',
    /**
     * @value This page gives you access to all content created.
     */
    NO_CONTENT_MESSAGE = 'CONTENT_ADMIN.NO_CONTENT_MESSAGE',
    /**
     * @value No content yet
     */
    NO_CONTENT_TITLE = 'CONTENT_ADMIN.NO_CONTENT_TITLE',
    /**
     * @value {"one":"%NUMBER% content","other":"%NUMBER% content"}
     */
    NUMBER_CONTENT = 'CONTENT_ADMIN.NUMBER_CONTENT',
    /**
     * @value {"one":"%NUMBER% content out of many","other":"%NUMBER% content out of many"}
     */
    NUMBER_CONTENT_OUT_OF_MANY = 'CONTENT_ADMIN.NUMBER_CONTENT_OUT_OF_MANY',
    /**
     * @value {"one":"%NUMBER% content selected out of many","other":"%NUMBER% content selected out of many"}
     */
    NUMBER_CONTENT_OUT_OF_MANY_SELECTED = 'CONTENT_ADMIN.NUMBER_CONTENT_OUT_OF_MANY_SELECTED',
    /**
     * @value {"one":"%NUMBER% content selected","other":"%NUMBER% content selected"}
     */
    NUMBER_CONTENT_SELECTED = 'CONTENT_ADMIN.NUMBER_CONTENT_SELECTED',
    /**
     * @value Only one bulk action can work at a time.
     */
    ONLY_ONE_BULK = 'CONTENT_ADMIN.ONLY_ONE_BULK',
    /**
     * @value These changes may take a few minutes. Refresh, to check the status of the update.
     */
    REFRESH_TO_CHECK_STATUS = 'CONTENT_ADMIN.REFRESH_TO_CHECK_STATUS',
    /**
     * @value Select a person
     */
    SELECT_A_PERSON = 'CONTENT_ADMIN.SELECT_A_PERSON',
    /**
     * @value Results from a semantic search can include content that is not displayed in this list. Any action you select applies to all matched results, including ones you have not reviewed.
     * @description Warning shown on the content bulk list when a bulk action targets a semantic-search "select all" result set (includes items not shown/reviewed). CMS-2343.
     */
    SEMANTIC_SEARCH_BULK_WARNING = 'CONTENT_ADMIN.SEMANTIC_SEARCH_BULK_WARNING',
    /**
     * @value Some changes may be ignored if they are not compatible with the selected piece of content.
     */
    SOME_CHANGES_MAY_BE_IGNORED = 'CONTENT_ADMIN.SOME_CHANGES_MAY_BE_IGNORED',
    /**
     * @value Some pieces of content may be ignored because their status is not compatible with the selected action.
     */
    SOME_CONTENT_MAY_BE_IGNORED = 'CONTENT_ADMIN.SOME_CONTENT_MAY_BE_IGNORED',
    /**
     * @value {"one":"You can unarchive this content at any time.","other":"You can unarchive these pieces of content at any time."}
     */
    TO_REVERSE_ARCHIVE = 'CONTENT_ADMIN.TO_REVERSE_ARCHIVE',
    /**
     * @value {"one":"You can unpublish this content at any time.","other":"You can unpublish these pieces of content at any time."}
     */
    TO_REVERSE_PUBLISH = 'CONTENT_ADMIN.TO_REVERSE_PUBLISH',
    /**
     * @value {"one":"To reverse this action, you can publish this piece of content again.","other":"To reverse this action, you can publish these pieces of content again."}
     */
    TO_REVERSE_UNPUBLISH = 'CONTENT_ADMIN.TO_REVERSE_UNPUBLISH',
    /**
     * @value Unable to update %CONTENT_COUNT% content.
     */
    UNABLE_TO_UPDATE_MUTIPLE_CONTENT = 'CONTENT_ADMIN.UNABLE_TO_UPDATE_MUTIPLE_CONTENT',
    /**
     * @value Unpublish
     */
    UNPUBLISH = 'CONTENT_SET_TO_DRAFT',
    /**
     * @value Updating content
     * @description Title of the notification that is displayed while waiting for the end of a bulk operation
     */
    UPDATING_CONTENT = 'CONTENT_ADMIN.UPDATING_CONTENT',
    /**
     * @value %AUTHOR% on behalf of %WRITER%
     * @description Text displayed to indicate that someone created (the author) a content on behalf of someone else (the writer)
     */
    USER_ON_BEHALF_OF = 'CONTENT_ADMIN.USER_ON_BEHALF_OF',
    /**
     * @value The value cannot be the same in both fields.
     */
    VALUE_CANNOT_BE_SIMILAR_IN_BOTH_FIELDS = 'CONTENT_ADMIN.VALUE_CANNOT_BE_SIMILAR_IN_BOTH_FIELDS',
}
